import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { FideicomisoProvider } from "../../lib/fideicomiso";
import { TenantProvider } from "../../lib/tenant";
import { Toaster } from "../ui/sonner";

export default function AppLayout() {
    return (
        <TenantProvider>
            <FideicomisoProvider>
                <div className="min-h-screen flex bg-background">
                    <Sidebar />
                    <div className="flex-1 flex flex-col min-w-0">
                        <Header />
                        <main className="flex-1 overflow-y-auto">
                            <Outlet />
                        </main>
                    </div>
                    <Toaster position="top-right" richColors closeButton />
                </div>
            </FideicomisoProvider>
        </TenantProvider>
    );
}
